module.exports = __webpack_public_path__ + "static/media/loading.4361e863.gif";